import React from 'react'
import { BeatLoader } from 'react-spinners'
import { css } from '@emotion/react'
import * as S from './styled'

type PendingCardProps = {
  listView: boolean
}

const override = css`
  display: flex;
  margin: 0 7px;
  border-color: red;

  position: absolute;
  top: 45%;
`

const PendingCard: React.FC<PendingCardProps> = ({ listView }) => {
  return (
    <>
      {!listView && (
        <S.Card>
          <BeatLoader css={override} loading size={15} />
        </S.Card>
      )}
      {listView && (
        <S.ListCard>
          <BeatLoader css={override} loading size={10} />
        </S.ListCard>
      )}
    </>
  )
}
export default PendingCard
